import 'babel-polyfill';
import React from 'react';
import Menu, { MenuItem } from 'rc-menu';
import { withRouter } from 'react-router';

import AppLauncher from './AppLauncher';
import Account from './Account';

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultSelectedKeys: [this.currentPathKey(this.props.location.pathname)]
    };
    this.history = props.history;
  }

  currentPathKey(currentPath) {
    if (currentPath.startsWith('/common')) {
      return '1';
    } else if (currentPath.startsWith('/service')) {
      return '2';
    }
  }

  onClick(info) {
    switch (info.key) {
      case '1':
        this.props.history.push('/common/top');
        break;
      case '2':
        this.props.history.push('/service/top');
        break;
    }
  }

  getMenu() {
    return (
      <div className="header-bar-area">
        <Menu
          mode="horizontal"
          defaultSelectedKeys={this.state.defaultSelectedKeys}
          onClick={this.onClick.bind(this)}
        >
          <MenuItem key="0" disabled>
            BOIS
          </MenuItem>
          <MenuItem key="1">共通</MenuItem>
          <MenuItem key="2">サービス</MenuItem>
        </Menu>

        <AppLauncher />
        <Account />
      </div>
    );
  }

  render() {
    return (
      <header id="global-navigation">
        <div>
          <div>{this.getMenu()}</div>
        </div>
      </header>
    );
  }
}

export default withRouter(TopBar);
